import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { PatientService, User, UserService } from '../../shared';

@Component({
  selector: 'app-questions1',
  templateUrl: './questions1.component.html',
  styleUrls: ['../style.component.css', './questions1.component.css']
})
export class Questions1Component implements OnInit {
  public selectques = [];
  public selectques1 = [];
  currentUser: User
  public Select = {
    quest1: "",
    quest2: "",
    quest3: "",
    answer1: "",
    answer2: "",
    answer3: ""
  }
  patid: any;
  welcome: any;
  modalRef: any;
  params: any;
  public myobj: any = {};
  public myobj1: any = {};
  resdata: any;
  question: any = [];
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
  }
  constructor(
    private patientservice: PatientService,
    private userService: UserService,
    private routerr: ActivatedRoute,
    private toast: ToastrService,
    private modalService: BsModalService,
    private nav: Router
  ) { }

  ngOnInit() {


    this.routerr.params.subscribe(params => {
      this.params = params
      this.patientservice.changeNav(params['id'])
      this.patid = params['id']
      //  ////console.log(this.params)
    });
    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        if (this.routerr.snapshot.url[0].path == 'questions') {
          this.currentUser.status = true
        }
        //this.userService.currentUserSubject.next(this.currentUser);

      }
    )

    this.patientservice
      .getquestions()
      .subscribe(
        data => {

          //////console.log(data);
          if (data) {

            this.question = data;
          }
          else {


          }
        }
      );

  }
  ques(qa) {
    // ////console.log(qa.value)
    let ans = {
      //"userAccountId": this.patid,
      "secQuestionOne": qa.value.quest1,
      "secQuestionTwo": qa.value.quest2,
      "secQuestionThree": qa.value.quest3,
      "secQusAnswerOne": qa.value.answer1,
      "secQusAnswerTwo": qa.value.answer2,
      "secQusAnswerThree": qa.value.answer3,
      "activationMode": window.localStorage['firsttimeuser'] == 1 ? 'F' : 'M'
    }
    // ////console.log(ans)

    this.patientservice
      .getquesti(ans, this.patid, false)
      .subscribe(
        data => {
          // ////console.log(data)

          if (data) {
            this.userService.logAudit('saveSecurityQuestions', 0).subscribe(data => { })
            this.nav.navigate([`/login`])
          }
          else {
            this.toast.error(this.userService.translateText('patient_portal.display_messages.invalid_data.error'))
          }
        }
      )

  }
  getuniquelist(event) {

    this.selectques = _.reject(this.question, (o: any): any => {
      return o.userSecQuestionsId == event
    })

    //  ////console.log(this.selectques)
  }
  getlist(event) {

    this.selectques1 = _.reject(this.selectques, (o: any): any => {
      return o.userSecQuestionsId == event
    })

    //  ////console.log(this.selectques1)
  }


  // logout() {
  //   this.userService.purgeAuth();
  //   if(window.localStorage['plogin'])
  //   {
  //     var plogin = window.localStorage['plogin']
  //     window.localStorage.removeItem('plogin');
  //     this.nav.navigateByUrl('/plogin/'+plogin);

  //   }
  //   else
  //   this.nav.navigateByUrl('/login');

  // }

}
